import { auth } from '../firebase';
import { API_BASE_URL } from '../config';

const mapRoleToLabel = (role) => {
  const r = String(role || '').trim().toLowerCase();
  if (r === 'sysadmin' || r === 'system_admin' || r === 'system admin') return 'System Admin';
  if (r === 'admin') return 'Admin';
  return 'User';
};

export const listUsers = async () => {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    const err = new Error('Not signed in.');
    err.code = 'AUTH_REQUIRED';
    throw err;
  }

  // Avoid forced token refresh on every call to reduce stalls in UI loading.
  const idToken = await currentUser.getIdToken();
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), 12000);

  let resp;
  try {
    resp = await fetch(`${API_BASE_URL}/api/users`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
      signal: controller.signal,
    });
  } catch (error) {
    if (error?.name === 'AbortError') {
      const err = new Error('Request timed out while loading users.');
      err.code = 'USERS_LOAD_TIMEOUT';
      throw err;
    }
    throw error;
  } finally {
    window.clearTimeout(timeoutId);
  }

  const payload = await resp.json().catch(() => ({}));
  if (!resp.ok || payload?.ok !== true || !Array.isArray(payload?.users)) {
    const message = payload?.error || 'Failed to load users.';
    const err = new Error(message);
    err.code = 'USERS_LOAD_FAILED';
    throw err;
  }

  return payload.users.map((u) => ({
    uid: u.uid,
    name: u.name || '',
    username: u.username || '',
    email: u.email || '',
    profilePhoto: u.profilePhoto || u.photoURL || u.photoUrl || u.profile?.profilePhoto || null,
    role: mapRoleToLabel(u.role),
    isVerified: u.isVerified === true,
    createdAtMs: typeof u.createdAtMs === 'number' ? u.createdAtMs : null,
    lastLoginMs: typeof u.lastLoginMs === 'number' ? u.lastLoginMs : null,
    lastSeenAtMs: typeof u.lastSeenAtMs === 'number' ? u.lastSeenAtMs : null,
    location: u.location || null,
    adminaccessLevel: u.adminaccessLevel || 'none',
    purchasedCredits: Number(u.purchasedCredits || 0),
    freeCredits: Number(u.freeCredits || 0),
  }));
};
